export default __webpack_public_path__ + "static/media/savings.0e65f936.gif";